import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import { Provider } from "react-redux";
import { store } from "store/store.ts";
import { MainRouter } from "./main-router";
import { Toaster } from "./components/ui/sonner";
import { TooltipProvider } from "./components/ui/tooltip";
import { WithModalState } from "./@libs/modal-panels/modal-state-context";
import * as Sentry from "@sentry/react";
import { GlobalErrorBoundary } from "./error-boundary";

Sentry.init({
  dsn: "https://3f6a21a88a980f3ec06971d7e878c785@o288872.ingest.us.sentry.io/4509240918278144",
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
});

(window as any).appStartedTime = Date.now();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <TooltipProvider>
      <WithModalState>
        <Provider store={store}>
          <GlobalErrorBoundary>
            <MainRouter />
            <Toaster />
          </GlobalErrorBoundary>
        </Provider>
      </WithModalState>
    </TooltipProvider>
  </StrictMode>
);
